import styled from '@emotion/styled'
import theme from '../../../styles/theme'
import { mq } from '../../../lib/hooks'

export const Ticket = styled.a`
  display: flex;
  color: ${theme.colors.white.primary3};
  align-items: center;
  padding: 0px;
  user-select: none;
  border: none;
  background: transparent;
  cursor: pointer;

  @media screen and (max-width: 342px) {
    margin: 0px 8px;
  }
  &:hover {
    & > span,
    & > svg {
      opacity: 0.75;
    }
  }

  .Ticket__Label {
    color: ${theme.colors.white.primary};
    &.Ticket__Label--onDrawer {
      color: ${theme.colors.white.primary};
    }

    ${mq('lg')} {
      color: ${theme.colors.white.primary};

      &.Ticket__Label--isSticky {
        color: ${theme.colors.white.primary};
      }
    }
  }

  .Ticket__Icon {
    &.Ticket__Icon--onDrawer {
      fill: ${theme.colors.white.primary};
    }

    ${mq('lg')} {
      fill: ${theme.colors.white.primary};
      margin-bottom: 2px;
      &.Ticket__Icon--isSticky {
        fill: ${theme.colors.white.primary3};
      }
    }
  }
`
